import React from 'react';
import PropTypes from 'prop-types';

import ProgressCard from '../progress-card-component';

const Directness = (props) => {
  const {
    percentage,
  } = props;

  const description = `The chart shows the percentage of participants that selected the correct answer without backtracking.
Across all tasks, ${percentage}% of participants selected the correct answer without backtracking.`;

  return (
    <ProgressCard
      title="Directness"
      percentage={percentage}
      description={description}
    />
  );
};

Directness.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default Directness;
